export const EndPoint = {
  clientPath: '/api/init',
  screen: '/v2/api/screensavers',
  machinesV2: '/v2/api/machines',
  auth: '/api/auth',
  deskAuth: '/api/desktop-auth',
  languages: '/api/languages',
  floors: '/api/floors',
  tenants: '/api/tenants',
  tenantCategoryGroups: '/api/tenant-category-groups',
  menusV2: '/v2/api/main-menus',
  customPage: '/api/custom-pages/:customPageId',
  pointsV2: '/v2/api/points',
  poiContentKeywords: '/api/poi-content-keywords',
  customFields: '/api/poi-content-custom-fields/:poi-content-id',

  // 통계
  usages: '/api/metrics/usages', // 기기 사용량
  tenantsUsage: '/api/metrics/tenants', // 매장 사용량
  categoryGroupsUsage: '/api/metrics/tenant-category-groups', // 카테고리 사용량

  // mobile api
  screenByMobile: '/mobile/v2/screensavers',
  machinesV2ByMobile: '/mobile/machines',
  languagesByMobile: '/mobile/languages',
  floorsByMobile: '/mobile/floors',
  tenantsByMobile: '/mobile/tenants',
  tenantCategoryGroupsByMobile: '/mobile/tenant-category-groups',
  menusV2ByMobile: '/v2/mobile/main-menus',
  customPageByMobile: '/mobile/custom-pages/:customPageId',
  pointsV2ByMobile: '/mobile/v2/points',
  poiContentKeywordsByMobile: '/mobile/poi-content-keywords',
  customFieldsByMobile: '/mobile/poi-content-custom-fields/:poi-content-id',

  // 통계
  usagesByMobile: '/mobile/metrics/usages', // 기기 사용량

  // 주차안내
  parking: '/api/one-grove/parking/inout',
} as const;

export const ResourceEndpoints = {
  categoryIcon: '/image/did/category_icon',
} as const;
